// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadCrumb_breadcrumb__e40A8","breadcrumb-item":"BreadCrumb_breadcrumb-item__PuGGA","active":"BreadCrumb_active__WJ2ST"};